import styled from 'styled-components';
// import whatsappBackground from 'images/whatsapp-background';

export const ModalWrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  height: 100vh;

  /* background: url('/images/whatsapp-background'); */

  @media (min-width: 700px) {
    height: auto;
    bottom: auto;
    max-width: 50rem;
    border-radius: 1.2rem;

    position: absolute;
    left: 2.5rem;
    bottom: 10.5rem;
  }
`;

export const TopContainer = styled.div`
  background: ${({ theme }) => theme.colors.darkGreen};
  height: 8rem;
  padding: 0.8rem 1.6rem;

  display: flex;
  align-items: flex-start;
  gap: 2.4rem;

  @media (min-width: 700px) {
    border-radius: 1.2rem 1.2rem 0 0;
  }
`;

export const CompanyInfo = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.8rem;

  p {
    font-weight: 600;
    font-size: 2.4rem;
    line-height: 2.9rem;
    color: ${({ theme }) => theme.colors.white};
  }

  p:last-child {
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 1.9rem;
  }
`;

export const CloseModalButton = styled.button`
  margin-left: auto;
  background: transparent;
  border: none;
`;

export const Content = styled.div`
  padding: 1.8rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const ServiceMessage = styled.p`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 1.2rem;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.blackText};
  padding: 1.6rem;
  width: fit-content;
  white-space: pre-wrap;
`;

export const WhatsappAnchor = styled.a`
  display: block;
  background: ${({ theme }) => theme.colors.darkGreen};
  border-radius: 0.4rem;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: ${({ theme }) => theme.colors.white};
  width: fit-content;
  padding: 1rem 1.6rem;
  margin-left: auto;
`;
